import './styles.css';
import { mountAfterworld } from './afterworld';
import { mountScrollWorld } from './scroll-world';
import { siteConfig } from './site.config';

const app = document.querySelector<HTMLElement>('#app');

if (!app) {
  throw new Error('Missing #app mount point');
}

mountScrollWorld(app, siteConfig);
mountAfterworld(app);
